/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import castArray from 'lodash/castArray';

import Typography from '@atoms/Typography';
import Block from '@atoms/Block';

import s from './styles.module.less';

const formatApiError = ({ json, concatenateApiErrors, apiErrorWithKey = true }) => {
  if (!json?.errors || !json?.title) return null;

  if (concatenateApiErrors)
    return Object.entries(json.errors).reduce(
      (acc, [key, err]) => (apiErrorWithKey ? `${acc}${key}: ${err.join('\n')}\n` : `${acc}\n${err.join('\n')}\n`),
      '',
    );

  return json.title;
};

const BaseErrorMessage = ({
  as: Component = 'div',
  className,
  style,
  errors,
  children,
  gutter = 20,
  variant,
  defaultMessage = 'An error occurred',
  concatenateApiErrors,
  apiErrorWithKey,
  ...props
}) => (
  <Component
    role="alert"
    className={clsx(className, s.root, s[variant])}
    style={{ '--gutter': `${gutter}px`, ...style }}
    {...props}
  >
    {errors.map((err, i) => (
      <Typography.Paragraph key={i} className={s.error}>
        {formatApiError({ json: err?.json, concatenateApiErrors, apiErrorWithKey }) ||
          err?.message ||
          (typeof err === 'string' ? err : defaultMessage)}
      </Typography.Paragraph>
    ))}
  </Component>
);

const ErrorMessage = ({ error, variant, defaultMessage, concatenateApiErrors, apiErrorWithKey, ...props }) => {
  const errors = React.useMemo(() => castArray(error).filter(Boolean), [error]);

  if (errors.length === 0) return null;

  if (variant === 'block') {
    return (
      <Block {...props} variant="error">
        <BaseErrorMessage
          errors={errors}
          defaultMessage={defaultMessage}
          variant="block"
          concatenateApiErrors={concatenateApiErrors}
          apiErrorWithKey={apiErrorWithKey}
        />
      </Block>
    );
  }

  return (
    <BaseErrorMessage
      errors={errors}
      variant={variant}
      concatenateApiErrors={concatenateApiErrors}
      apiErrorWithKey={apiErrorWithKey}
      {...props}
    />
  );
};

export default ErrorMessage;
